module.exports = __webpack_public_path__ + "static/media/logo_intel.9e1410bb.png";